/**
 * Activités lancées ou non — réglage commun à tout l'affichage web.
 *
 * Béton prêt à l'emploi (BPE) — décisions PDG du 30/09/2026 (D4 puis plan
 * « menus BPE ») : LEADBETON ne fait aujourd'hui que du préfabriqué, compté en
 * pièces, et ne possède aucun camion malaxeur. Tant que ce réglage vaut `false` :
 *  - le tableau de bord béton masque la carte « Toupies actives » et les
 *    panneaux « Flotte toupies », « Chantiers en cours » et « Planning
 *    production » (exprimé en m³) ;
 *  - le menu de gauche masque les entrées marquées `bpe: true`
 *    (aujourd'hui « Flotte toupies (BPE) » seulement — « Chantiers » et
 *    « Gâchées » servent aussi au préfabriqué et restent visibles) ;
 *  - l'adresse `/operations/flotte` d'une filiale béton affiche « Activité BPE
 *    non lancée » au lieu de la liste des toupies.
 *
 * Le code BPE est gardé : passer à `true` le jour du lancement du BPE. Un
 * réglage par société, en base et modifiable sans redéployer, est prévu pour
 * le lot de lancement du BPE.
 */
export const BPE_EN_SERVICE = false;
